import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f207a986"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "design-warning"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 28C16.7075 28.0022 18.3986 27.6669 19.9761 27.0135C21.5537 26.36 22.9865 25.4013 24.1923 24.1923C25.4013\n         22.9865 26.36 21.5537 27.0135 19.9761C27.6669 18.3986 28.0022 16.7075 28 15C28.0022 13.2925 27.6669 11.6014 27.0134\n         10.0239C26.36 8.44636 25.4012 7.01353 24.1923 5.80771C22.9865 4.59873 21.5537 3.63996 19.9761 2.98651C18.3986 2.33305\n         16.7075 1.9978 15 2.00001C13.2925 1.99783 11.6014 2.3331 10.0239 2.98656C8.44636 3.64001 7.01353 4.59876 5.80771\n         5.80771C4.59876 7.01353 3.64001 8.44636 2.98656 10.0239C2.3331 11.6014 1.99783 13.2925 2.00001 15C1.9978 16.7075\n         2.33305 18.3986 2.98651 19.9761C3.63996 21.5537 4.59873 22.9865 5.80771 24.1923C7.01353 25.4012 8.44636 26.36\n         10.0239 27.0134C11.6014 27.6669 13.2925 28.0022 15 28Z",
    stroke: "white",
    "stroke-width": "3",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M15 23.4497C15.431 23.4497 15.8443 23.2785 16.149 22.9738C16.4538\n         22.669 16.625 22.2557 16.625 21.8247C16.625 21.3937 16.4538 20.9804 16.149 20.6757C15.8443 20.3709 15.431 20.1997\n         15 20.1997C14.569 20.1997 14.1557 20.3709 13.851 20.6757C13.5462 20.9804 13.375 21.3937 13.375 21.8247C13.375 22.2557\n         13.5462 22.669 13.851 22.9738C14.1557 23.2785 14.569 23.4497 15 23.4497Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 7.19971V17.5997",
    stroke: "white",
    "stroke-width": "3",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_3 = { class: "layout-topbar-icons p-d-flex p-justify-between" }
const _hoisted_4 = { class: "p-d-flex p-ai-lg-center p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Gamification = _resolveComponent("Gamification")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_creator_menu = _resolveComponent("creator-menu")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout-topbar", { 'layout-topbar-big': !_ctx.isSmallSidebar, 'scroll-topbar': !_ctx.scrollY,
  'background-dark': _ctx.isNewDesignEnabled, 'topbar-with-warning': _ctx.isNewDesignEnabled && !_ctx.isDashboard}])
  }, [
    (_ctx.isNewDesignEnabled && !_ctx.isDashboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(" You are now in the new version of G.IO. "),
          _createElementVNode("a", {
            class: "design-switch-link",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSwitch && _ctx.handleSwitch(...args)))
          }, "Switch to the old version.")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isNewDesignEnabled && _ctx.userIsBrand)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "new-button",
              onClick: _ctx.goToCreateCampaign
            }, {
              default: _withCtx(() => [
                _createTextVNode("+ New Campaign")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isNewDesignEnabled && _ctx.userIsCreator)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "new-button",
              onClick: _ctx.goToCreateContent
            }, {
              default: _withCtx(() => [
                _createTextVNode("+ Create Content")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Gamification, { style: {"display":"none"} }),
        _createVNode(_component_Notifications, { "is-brand": _ctx.userIsBrand }, null, 8, ["is-brand"]),
        _createVNode(_component_creator_menu)
      ]),
      _createVNode(_component_Menu, {
        id: "menu",
        ref: "menuRef",
        model: _ctx.userMenuItems,
        popup: true,
        appendTo: 'body'
      }, null, 8, ["model"])
    ])
  ], 2))
}